import { FileText, Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@ideoz/ui';
import { EmptyState } from '@ideoz/ui/components/molecules/EmptyState';

interface FilesEmptyStateProps {
  onUpload: () => void;
}

export function FilesEmptyState({ onUpload }: FilesEmptyStateProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <EmptyState
      title={t('filesHub.emptyTitle')}
      description={t('filesHub.emptyDesc')}
      action={
        <Button onClick={onUpload} variant="outline" size="sm">
          {t('filesHub.uploadFirst')}
        </Button>
      }
    />
  );
}
